<template>
  <div id="resource-bookings-page">
    <h2 class="intro-y text-lg font-medium mt-10">
      會議室及資源預借
    </h2>

    <div v-if="checkPermission(permissions, 'site.resource-booking.view')" class="mt-5">
      <div class="fixed box event-info text-white" v-if="hoverEvent" style="background-color: #f59714;" :style="`top: ${hoverRect.top + 2 + hoverRect.height}px; left: ${hoverRect.left}px;`">
        資源：{{ hoverEvent.resource }}<br>
        簡介：{{ hoverEvent.name }}<br>
        日期：{{
          $moment(hoverEvent.from_time).format('YYYY年MM月DD日 HH:mm')
        }}{{ hoverEvent.to_time == null ? '' : (' - ' + $moment(hoverEvent.to_time).format('YYYY年MM月DD日 HH:mm')) }}
      </div>

      <ul v-if="false" class="nav nav-tabs mt-5" role="tablist">
        <li v-for="(item, key) in options" :key="key" :id="`${item.value}-tab`" class="nav-item flex-1"
            role="presentation">
          <template v-if="item.value === 'my'">
            <button class="nav-link w-full py-2" :class="{'active': option === item.value}" type="button" @click="option = item.value"> {{ item.key }}
            </button>
          </template>
        </li>
      </ul>

      <div class="tab-content border-l border-r border-b mb-5">
        <div class="tab-pane leading-relaxed p-5" :class="{'active': option === 'my'}">
          <div v-if="option === 'my'" class="flex flex-wrap sm:flex-nowrap justify-between align-items-bottom w-full intro-y">
            <div class="flex flex-column justify-end mb-1 sm:mb-0">
              <router-link v-if="checkPermission(permissions, 'site.resource-booking.create')" to="/create-resource-booking" class="btn btn-primary shadow-md ">預約</router-link>
            </div>

            <div v-if="!loading" class="mt-3 sm:mt-0 flex w-full sm:w-auto">
              <select id="resource_type" v-model="resourceType" class="form-select w-44 mr-2" aria-label="請選擇類別">
                <option value="">物品及會議室</option>
                <option v-for="(item, key) in getResourceTypes(currentSite)" :key="key" :value="item.value">{{ item.key }}</option>
              </select>

              <select id="site_id" v-model="resourceId" class="form-select w-44" aria-label="請選擇資源" :disabled="resourceType === ''">
                <option value="">全部</option>
                <option v-for="(item, key) in filterResources" :key="key" :value="item.resource_id">{{ item.name }}</option>
              </select>

              <button v-if="!downloading && currentSite != null && currentSite.is_roster_site" class="btn btn-secondary shadow-md ml-2 no-print" @click="openDownloadModal">下載記錄</button>

              <span v-show="downloading"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
            </div>
            <div v-show="loading" class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0 flex">
              <span><i data-loading-icon="oval" class="w-8 h-8"></i></span>
            </div>
          </div>

          <FullCalendar class="mt-4 intro-y" :options="calendarOptions"/>
        </div>

        <div class="tab-pane leading-relaxed p-5" :class="{'active': option === 'manage'}">

          <div class="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center">
            <div class="hidden md:block mx-auto text-slate-500">正在顯示第 {{ resourceBookings.length !== 0 ? from : 0 }}
              至 {{ to ?? 0 }} 個預約
            </div>

            <div class="mt-3 sm:mt-0 flex">
              <button v-if="!downloading && currentSite != null && currentSite.is_roster_site && option === 'manage'" class="btn btn-primary shadow-md mr-2 btn-download" @click="openDownloadModal">下載記錄</button>
              <span v-show="downloading"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
            </div>
          </div>

          <!-- BEGIN: Data List -->
          <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table class="table table-striped">
              <thead>
              <tr>
                <th v-if="option === 'manage'" class="whitespace-nowrap">
                  <order-button title="員工" column="user_id" :order-by.sync="orderBy" :order.sync="order" :disabled="this.option === 'my'"></order-button>
                </th>
                <th class="whitespace-nowrap">
                  <order-button title="資源" column="resource_id" :order-by.sync="orderBy" :order.sync="order" :disabled="this.option === 'my'"></order-button>
                </th>
                <th class="whitespace-nowrap">
                  <order-button title="借用日期" column="from_time" :order-by.sync="orderBy" :order.sync="order" :disabled="this.option === 'my'"></order-button>
                </th>
                <th class="whitespace-nowrap">
                  <order-button title="歸還日期" column="to_time" :order-by.sync="orderBy" :order.sync="order" :disabled="this.option === 'my'"></order-button>
                </th>
                <th class="text-center whitespace-nowrap">檢視</th>
                <th v-if="false" class="whitespace-nowrap">
                  <order-button title="狀態" column="booking_status" :order-by.sync="orderBy" :order.sync="order" :disabled="this.option === 'my'"></order-button>
                </th>
                <th
                  v-if="checkPermission(permissions, ['site.resource-booking.edit', 'site.resource-booking.delete'])"
                  class="text-center whitespace-nowrap">動作
                </th>
              </tr>
              </thead>
              <tbody>
              <tr class="" v-for="(item, key) in resourceBookings" :key="key">
                <td v-if="option === 'manage'">{{ item.user ? item.user.display_name : '' }}</td>
                <td>{{ item.resource != null ? item.resource.name : '-' }}</td>
                <td>{{ item.from_time ?? '-' }}</td>
                <td>{{ item.to_time ?? '-' }}</td>
                <td class="table-report__action text-center">
                  <router-link :to="`/resource-bookings/${item.booking_id}`" class="btn btn-success">
                    <font-awesome-icon icon="fa-regular fa-eye" class="text-white"/>
                  </router-link>
                </td>
                <td v-if="false">
                  {{ getObjectValue(allStatus, 'value', item.booking_status, 'name') }}
                  <div v-if="item.approval_remark" class="text-pending">{{ item.approval_remark }}</div>
                </td>
                <td class="table-report__action w-120">
                  <div class="flex justify-center items-center">
                    <router-link v-if="profile.user_id === item.user_id || checkPermission(permissions, ['site.resource-booking.edit'])" :to="`/update-resource-booking/${item.booking_id}`" class="flex items-center mr-3">
                      <font-awesome-icon icon="fa-solid fa-pen-to-square"/>
                      &nbsp;更改
                    </router-link>
                    <button class="flex items-center text-danger mr-3" v-if="checkPermission(permissions, ['site.resource-booking.delete'])" @click="openDeleteModal(item.booking_id)">
                      <font-awesome-icon icon="fa-regular fa-trash-can" />
                      &nbsp;刪除 </button>

                    <button v-if="false && option === 'manage' && item.booking_status === 'Pending'" type="button" @click="openModal('accept', item.booking_id)" class="flex items-center mr-3 text-success mr-3">
                      <font-awesome-icon icon="fa-regular fa-square-check"/>
                      &nbsp;批准
                    </button>
                    <button v-if="false && option === 'manage' && item.booking_status === 'Pending'" type="button" @click="openModal('reject', item.booking_id)" class="flex items-center mr-3 text-danger mr-3">
                      <font-awesome-icon icon="fa-regular fa-circle-xmark"/>
                      &nbsp;拒絕
                    </button>
                    <button v-if="false && checkPermission(permissions, 'site.resource-booking.manage') && option === 'manage' && item.booking_status === 'Accepted' && $moment().isAfter(item.from_time) && $moment().isBefore(item.to_time)" type="button" @click="openModal('force-return', item.booking_id)"
                            class="flex items-center text-pending">
                      <font-awesome-icon icon="fa-solid fa-rotate-left"/>
                      &nbsp;強制歸還
                    </button>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- END: Data List -->

          <!-- BEGIN: Action Confirmation Modal -->
          <div id="download-modal" class="modal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body p-0">
                  <div class="p-5 text-center">
                    <div class="text-slate-500 mt-2">
                      請選擇下載紀錄日期<br><br>
                      <date-picker v-model="downloadDate" type="date" placeholder="請選擇下載紀錄日期" input-class="form-control w-full" format="YYYY-MM-DD"></date-picker>
                    </div>
                  </div>
                  <div class="px-5 pb-8 text-center">
                    <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">取消
                    </button>
                    <button type="button" data-tw-dismiss="modal" class="btn btn-primary w-24 text-white" :disabled="downloadDate == null"
                            @click="onDownload">下載
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END: Action Confirmation Modal -->

          <!-- BEGIN: Action Confirmation Modal -->
          <div id="action-confirmation-modal" class="modal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body p-0">
                  <div class="p-5 text-center">
                    <font-awesome-icon v-if="action === 'accept'" icon="fa-regular fa-square-check"
                                       class="fa-3x text-success"/>
                    <font-awesome-icon v-else-if="action === 'reject'" icon="fa-regular fa-circle-xmark"
                                       class="fa-3x text-danger"/>
                    <font-awesome-icon v-else-if="action === 'force-return'" icon="fa-solid fa-rotate-left"
                                       class="fa-3x text-pending"/>
                    <div class="text-3xl mt-5">你確定嗎？</div>
                    <div class="text-slate-500 mt-2">
                      <span v-if="action === 'accept'">你是否要批准此預約？</span>
                      <span v-else-if="action === 'reject'">你是否要拒絕此預約？</span>
                      <span v-else-if="action === 'force-return'">你是否要強制歸還此資源？</span>
                      <br>
                      這動作不能還原。
                    </div>
                  </div>
                  <div class="px-5 pb-8 text-center">
                    <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">取消
                    </button>
                    <button type="button" class="btn w-24 text-white"
                            :class="{'btn-success': action === 'accept', 'btn-danger': action === 'reject', 'btn-pending': action === 'force-return'}"
                            @click="onConfirm">確定
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END: Action Confirmation Modal -->

          <!-- BEGIN: Delete Confirmation Modal -->
          <div id="delete-confirmation-modal" class="modal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body p-0">
                  <div class="p-5 text-center">
                    <font-awesome-icon icon="fa-regular fa-circle-xmark" class="fa-3x text-danger" />
                    <div class="text-3xl mt-5">你確定嗎？</div>
                    <div class="text-slate-500 mt-2">
                      你是否要刪除此預借？
                      <br>
                      這動作不能還原。
                    </div>
                  </div>
                  <div class="px-5 pb-8 text-center">
                    <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">取消</button>
                    <button type="button" class="btn btn-danger w-24" @click="onDelete">確定</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END: Delete Confirmation Modal -->
        </div>
      </div>

      <!-- BEGIN: Pagination -->
      <pagination-row v-if="option === 'manage'" :pages="pages" :current-page.sync="currentPage"
                      :item-per-page.sync="itemPerPage"></pagination-row>
      <!-- END: Pagination -->
    </div>

    <div v-else-if="mounted">
      <div class="alert alert-danger show mt-2" role="alert">沒有權限查看</div>
    </div>
  </div>
</template>

<script>
import interactionPlugin from '@fullcalendar/interaction'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import FullCalendar from '@fullcalendar/vue'

export default {
  props: ['auth', 'currentSite', 'permissions', 'profile'],
  components: {
    FullCalendar
  },
  data() {
    return {
      mounted: false,
      loading: 0,

      currentStart: null,
      currentEnd: null,
      currentViewType: null,

      hoverEvent: null,
      hoverRect: null,

      resources: [],
      resourceBookings: [],
      filterResources: [],
      sites: [],

      deleteId: null,

      downloading: false,

      option: 'my',
      resourceType: '',
      resourceId: '',
      itemPerPage: 50,
      currentPage: 1,
      pages: 0,
      from: 0,
      to: 0,
      search: '',
      orderBy: '',
      order: '',

      options: [
        { key: '全部預約', value: 'my' },
        { key: '管理預約', value: 'manage' }
      ],

      allStatus: [
        { name: '全部', value: 'ALL' },
        { name: '已批准', value: 'Accepted' },
        { name: '已拒絕', value: 'Rejected' },
        { name: '等待審批', value: 'Pending' }
      ],

      downloadDate: new Date(),

      action: null,
      selectId: null,

      calendarOptions: {
        plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
        initialView: 'dayGridMonth',
        selectable: true,
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,listWeek'
        },
        buttonText: {
          today: '今天',
          month: '月',
          week: '周',
          day: '日',
          list: '表'
        },
        locale: 'zh-HK',
        events: [],
        initialDate: this.$moment(this.$route.query.date).isValid() ? this.$route.query.date : this.$moment().format('YYYY-MM-DD'),
        dateClick: (info) => {
          const now = new Date()
          if (this.checkPermission(this.permissions, 'site.resource-booking.create') && info.dateStr.match(/^\d{4}-\d{2}-\d{2}$/) && info.date >= new Date(now.getFullYear(), now.getMonth(), now.getDate())) {
            this.$router.push(`/create-resource-booking?date=${info.dateStr}`)
          }
        },
        eventClick: (info) => {
          const props = info.event.extendedProps
          this.$router.push(`/resource-bookings/${props.bookingId}`)
        },
        eventMouseEnter: (event, jsEvent, view) => {
          this.hoverRect = event.el.getBoundingClientRect()
          this.hoverEvent = event.event._def.extendedProps
        },
        eventMouseLeave: (event, jsEvent, view) => {
          this.hoverEvent = null
          this.hoverRect = null
        },
        datesSet: (event) => {
          this.currentStart = event.start
          this.currentEnd = event.end
          this.currentViewType = event.view.type
          this.loadResourceBookings()
        }
      }
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    currentSite() {
      this.init()
    },
    resourceType() {
      this.resourceId = ''

      const array = []
      for (let i = 0; i < this.resources.length; i++) {
        if (this.resources[i].resource_type === this.resourceType) {
          array.push(this.resources[i])
        }
      }

      this.filterResources = array
      this.filterResourcesBookings()
    },
    resourceId() {
      this.filterResourcesBookings()
    },
    option() {
      this.loadResourceBookings()
    },
    currentPage(val) {
      this.loadResourceBookings(false)
    },
    itemPerPage(val) {
      this.loadResourceBookings()
    },
    order() {
      this.loadResourceBookings()
    }
  },
  async mounted() {
    window.tailwind.svgLoader()

    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      if (this.auth && this.currentSite) {
        // await this.loadSites()
        await this.loadResources()
        // await this.loadResourceBookings()
        this.mounted = true
      }
    },
    async loadSites() {
      this.loading++

      this.sites = await this.getSites()

      this.loading--
    },
    async loadResources() {
      this.loading++

      const response1 = await this.getSiteResources(this.currentSite.site_id, '', '', 0)
      const response2 = await this.getSiteAvailableResources(this.currentSite.site_id, '', '', 0)
      const resources = [...response1.data, ...response2.data]
      this.resources = [...new Map(resources.map((m) => [m.resource_id, m])).values()]

      this.loading--
    },
    async loadResourceBookings(resetCurrentPage = true) {
      this.loading++

      let response

      if (this.option === 'my') {
        response = await this.getSiteResourceBookings(this.currentSite.site_id, 0, this.currentPage, '', '', this.$moment(this.currentStart).format('YYYY-MM-DD'), this.$moment(this.currentEnd).format('YYYY-MM-DD'))
      } else {
        response = await this.getSiteResourceBookings(this.currentSite.site_id, this.itemPerPage, this.currentPage, this.orderBy, this.order)
        this.pages = response.meta.page.last_page
        this.from = response.meta.page.from ?? 0
        this.to = response.meta.page.to ?? 0
      }

      this.resourceBookings = response.data

      if (this.option === 'my') {
        this.filterResourcesBookings()
      }

      if (resetCurrentPage) {
        this.currentPage = 1
      }

      this.loading--
    },
    filterResourcesBookings() {
      const events = []

      for (let i = 0; i < this.resourceBookings.length; i++) {
        const resourceBooking = this.resourceBookings[i]
        if (resourceBooking.resource != null && ((this.resourceType === '' || (this.resourceId === '' && this.resourceType === resourceBooking.resource.resource_type) || (this.resourceId === resourceBooking.resource.resource_id)))) {
          let title = (resourceBooking.description ? resourceBooking.description + ' ' : '') + '(' + resourceBooking.resource.name + ')'
          if (this.currentViewType === 'listWeek') {
            title += ' (借用人/單位：' + (resourceBooking.borrower ?? '-') + ') (備茶：' + (resourceBooking.prepare_tea ? '是' : '否') + ') (冷氣：' + (resourceBooking.conditioner ? '是' : '否') + ') (備杯：' + (resourceBooking.prepare_cup ? '是' : '否') + ') (人數：' + (resourceBooking.people_num ?? '-') + ')'
          }
          const item = {
            title,
            name: resourceBooking.description,
            resource: resourceBooking.resource.name,
            start: resourceBooking.from_time,
            end: resourceBooking.to_time,
            from_time: resourceBooking.from_time,
            to_time: resourceBooking.to_time,
            bookingId: resourceBooking.booking_id,
            color: '#f59714'
          }

          events.push(item)
        }
      }
      this.calendarOptions.events = events
    },
    openModal(action, id) {
      this.action = action
      this.selectId = id

      const el = document.querySelector('#action-confirmation-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()
    },
    async onConfirm() {
      const el = document.querySelector('#action-confirmation-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.hide()

      let response

      let option = {
        title: '成功',
        message: '',
        type: 'success'
      }

      switch (this.action) {
        case 'accept':
          response = await this.acceptSiteResourceBooking(this.currentSite.site_id, this.selectId)
          option.message = '已批准預約'
          break
        case 'reject':
          response = await this.rejectSiteResourceBooking(this.currentSite.site_id, this.selectId)
          option.message = '已拒絕預約'
          break
        case 'force-return':
          response = await this.forceReturnSiteResourceBooking(this.currentSite.site_id, this.selectId)
          option.message = '已強制歸還資源'
          break
      }

      if (response.code === 0) {
        this.loadResourceBookings()
      } else {
        option = {
          title: '',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }

        switch (this.action) {
          case 'accept':
            option.title = '未能批准預約'
            break
          case 'reject':
            response = await this.rejectSiteResourceBooking(this.currentSite.site_id, this.selectId)
            option.title = '未能拒絕預約'
            break
          case 'force-return':
            response = await this.forceReturnSiteResourceBooking(this.currentSite.site_id, this.selectId)
            option.title = '未能強制歸還資源'
            break
        }
      }

      this.$notify(option)
    },
    openDownloadModal() {
      const el = document.querySelector('#download-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()
    },
    async onDownload() {
      this.downloading = true

      const date = this.$moment(this.downloadDate).format('YYYY-MM-DD')
      const response = await this.downloadResourceBookingRoster(this.currentSite.site_id, date, this.resourceType, this.resourceId)
      const blob = new Blob([response], { type: 'application/pdf' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `會議室及資源預借記錄(${date}).pdf`
      link.click()
      URL.revokeObjectURL(link.href)
      this.downloading = false
    },
    openDeleteModal(id) {
      this.deleteId = id

      const el = document.querySelector('#delete-confirmation-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()
    },
    async onDelete() {
      const el = document.querySelector('#delete-confirmation-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.hide()

      const response = await this.deleteSiteResourceBooking(this.currentSite.site_id, this.deleteId)

      let option = {
        title: '成功',
        message: '預借已被刪除',
        type: 'success'
      }

      if (response.code === 0) {
        this.loadResourceBookings()
      } else {
        option = {
          title: '未能刪除預借',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }
      }

      this.$notify(option)
    }
  }
}
</script>

<style lang="scss" scoped>
#resource-bookings-page {
  .tab-content {
    background-color: #FFF;
  }

  .btn-download {
    white-space: nowrap;
  }

  .svg-inline--fa {
    height: 10px;
  }

  .event-info {
    padding: 12px;
    z-index: 50;
  }
}
</style>
